import { PurchaseAreaCreatePage } from "@/features/purchase-area/pages/PurchaseAreaCreatePage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/purchase-area/create")({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["purchase_area.create"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: PurchaseAreaCreatePage,
});
